<app-header (fixedNavBar)="fixedHeader($event)"></app-header>
<div class="content-block" [ngClass]="{ 'content-margin' : isHeaderFixed && currentPage !== 'home' }">
    <router-outlet></router-outlet>
</div>
<app-footer></app-footer>
